// store/getters.js
export default {
  isLoading: state => state.isLoading,
};
